const parseChecks = checks => {
  if (!checks) return {};

  const items = {};
  checks.forEach(check => {
    const {
      createdAt,
      log: { checks: logs },
    } = check;
    for (let key in logs) {
      if (key === '__typename') continue;
      if (!items[key]) {
        items[key] = [];
      }
      const log = logs[key];
      items[key].push({
        date: createdAt,
        status: log.status,
        time: log.time,
        message: log.data,
      });
    }
  });
  return items;
};

export default parseChecks;
